import { getProjectStatus } from './projectStatuses';

export function isPastDueExpectedEndDate(project, today = new Date()) {
  const value = project?.Project_Expected_End_Date__c;
  if (!value) return false;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return false;

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    date.setFullYear(year, month - 1, day);
  }
  date.setHours(0, 0, 0, 0);

  const todayDate = new Date(today);
  todayDate.setHours(0, 0, 0, 0);
  if (date >= todayDate) return false;

  const completed = [project.Project_State__c, getProjectStatus(project.Project_Status__c)]
    .some(status => ['complete', 'completed'].includes(String(status || '').trim().toLowerCase()));
  return !completed;
}
